'use client'
import { AnimatePresence, motion } from 'framer-motion'

import logoB42 from '@/images/clients/b42/B42_Logo_onyx.svg'
import logoErgotopia from '@/images/clients/ergotopia/ergotopia.svg'
import logoFoodiary from '@/images/clients/foodairy/foodairy.svg'
import logoYou from '@/images/clients/you/you_logo.png'

import {
  type TargetHandle,
  targets,
  useTarget,
} from '@/components/TargetSelector'
import {
  TestimonialCard,
  type TestimonialData,
} from '@/components/TestimonialCard'

const testimonialsByTarget: Record<TargetHandle, TestimonialData> = {
  'health-apps': {
    quote:
      'Wir haben uns für eine Kooperation mit thepalia entschieden, weil sie genau die Brücke schlagen, die wir brauchen: Sie verstehen unsere digitale DNA als App, kennen aber gleichzeitig die regulatorischen Anforderungen im Detail.',
    name: 'Alexander Gschaider',
    role: 'Gründer & CEO @ B-42',
    logo: logoB42,
    href: 'https://www.b-42.com',
  },
  ecom: {
    quote:
      'Eine § 20 Zertifizierung für einen Onlinekurs ist zwar ein Gamechanger aber super aufwändig. In der Zusammenarbeit hat das thepalia-Team bewiesen, dass sie die perfekte Ergänzung für uns sind, weil sie uns an dieser Stelle den Rücken frei halten. Wir freuen uns, gemeinsam eine Kostenerstattung zu sichern und unseren Nutzern diesen enormen Mehrwert zu bieten.',
    name: 'Foodiary GmbH',
    role: '',
    logo: logoFoodiary,
    href: 'https://foodiary.app',
  },
  studios: {
    quote:
      'Für uns als Gesundheitszentrum ist es entscheidend, einen Partner zu haben, der uns nicht nur berät, sondern uns die technische und bürokratische Last im Betrieb abnimmt. Dank der Zusammenarbeit mit thepalia können wir uns voll auf unsere Patienten und Mitglieder konzentrieren, während unsere digitalen Angebote im Hintergrund für uns arbeiten.',
    name: 'Christopher Kutzer',
    role: 'Inhaber @ YOU Neuruppin',
    logo: logoYou,
    href: 'https://www.you-neuruppin.de',
  },
}

export function HeroTestimonial() {
  const { target, direction } = useTarget()
  const testimonial = testimonialsByTarget[target]

  // All quotes for height consistency (grid stacking)
  const allQuotes = Object.entries(testimonialsByTarget).map(([key, t]) => ({
    key,
    quote: t.quote,
  }))

  return (
    <AnimatePresence mode="wait" initial={false} custom={direction}>
      <motion.div
        key={target}
        custom={direction}
        initial="enter"
        animate="center"
        exit="exit"
        variants={{
          enter: (dir: number) => ({ opacity: 0, x: dir * 30 }),
          center: { opacity: 1, x: 0 },
          exit: (dir: number) => ({ opacity: 0, x: dir * -30 }),
        }}
        transition={{ duration: 0.4, ease: 'easeInOut' }}
        className="mx-auto max-w-5xl"
      >
        <TestimonialCard testimonial={testimonial} allQuotes={allQuotes} />
      </motion.div>
    </AnimatePresence>
  )
}
